import gql from 'graphql-tag';
import { participantFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const importParticipantsMutation = gql`
  mutation ImportParticipants($input: ParticipantImportInput!) {
    importParticipants(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminParticipantFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${participantFieldsFragment}
`;